var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("a-table", {
        key: "vtable-" + _vm.renderCount,
        attrs: {
          columns: this.getCols(),
          dataSource: _vm.items(),
          locale: {
            emptyText: _vm.$t("message.noRePresentativeFound"),
          },
          rowKey: "_id",
          size: "small",
        },
        on: { change: _vm.tableChange },
        scopedSlots: _vm._u([
          {
            key: "isOnlineSlot",
            fn: function (data, item) {
              return _c("div", { key: "isOnlineSlot-" + _vm.$i18n.locale }, [
                "undefined" !== typeof item.isOnline && item.isOnline
                  ? _c(
                      "span",
                      {
                        class: _vm.statuses.find(function (s) {
                          return s.status === item.status
                        }).class,
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "mr-2",
                          attrs: {
                            icon: _vm.statuses.find(function (s) {
                              return s.status === item.status
                            }).icon,
                          },
                        }),
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t(
                                _vm.statuses.find(function (s) {
                                  return s.status === item.status
                                }).langKey
                              )
                            ) +
                            "\n            "
                        ),
                      ],
                      1
                    )
                  : _c(
                      "span",
                      [
                        _c("font-awesome-icon", {
                          staticClass: "mr-2",
                          attrs: { icon: "power-off" },
                        }),
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("message.offline")) +
                            "\n            "
                        ),
                      ],
                      1
                    ),
              ])
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }